import { render } from "./ListPreguntas.vue?vue&type=template&id=691ce725"
import script from "./ListPreguntas.vue?vue&type=script&lang=js"
export * from "./ListPreguntas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__